export const ADD_ENGLISH_TESTSCORE_STARTED =
  'ADD_ENGLISH_TESTSCORE_STARTED';
export const ADD_ENGLISH_TESTSCORE_SUCCESS =
  'ADD_ENGLISH_TESTSCORE_SUCCESS';
export const ADD_ENGLISH_TESTSCORE_ENDED = 'ADD_ENGLISH_TESTSCORE_ENDED';
export const ADD_ENGLISH_TESTSCORE_ERROR = 'ADD_ENGLISH_TESTSCORE_ERROR';
